// extracted by mini-css-extract-plugin
export default {"appRoot":"Layout_appRoot__kqK27"};